import type { ItineraryProduct } from '@/types/products';

export function createSubtitleItineryProduct(itineraryProduct: ItineraryProduct) {
  const amountOfNights = Math.ceil(
    (new Date(itineraryProduct.endDate).getTime() - new Date(itineraryProduct.startDate).getTime()) /
      (1000 * 60 * 60 * 24),
  );

  const extra = itineraryProduct.ItineraryProductOptions?.find(
    (option) => option.type === 'mealplan',
  )?.name.toLowerCase();

  const included = itineraryProduct.ItineraryProductOptions?.find(
    (option) => option.type === 'included' && option.selected,
  )?.name.toLowerCase();

  // eslint-disable-next-line max-len, no-nested-ternary
  const text = `${amountOfNights} ${amountOfNights === 1 ? 'night' : 'nights'}${extra ? (included ? `, ${extra} included` : `, ${extra} excluded`) : ''}`;

  return text;
}
